import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const FontsComponent = ()=>{
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-300.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-regular.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-600.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "preload",
                href: "/static/fonts/poppins/poppins-v20-latin-700.woff2",
                as: "font",
                type: "font/woff2",
                crossOrigin: "anonymous"
            })
        ]
    });
};
export default FontsComponent;
